import { UIDataType } from "./types";

export function startLoading() {
  return {
    type: UIDataType.START_LOADING,
  };
}

export function stopLoading() {
  return {
    type: UIDataType.STOP_LOADING,
  };
}

export function startOpenAccountLookup() {
  return {
    type: UIDataType.START_OPEN_ACCOUNTS_LOOKUP,
  };
}

export function stopOpenAccountLookup() {
  return {
    type: UIDataType.STOP_OPEN_ACCOUNTS_LOOKUP,
  };
}

export function refreshHomePageData() {
  return {
    type: UIDataType.REFRESH_HOME_PAGE_DATA,
  };
}
